import { GuestyListings } from "../../../../models/integrations/guesty.models";
import { GuestyListingsDTO } from "../dtos";

export const mapGuestyListingsDTOToGuestyListings = (dto: GuestyListingsDTO[]): GuestyListings[] =>
  dto.map((listing) => ({
    _id: listing._id,
    nickname: listing.nickname,
    address: listing.address,
    title: listing.title,
  }));
